import { render, staticRenderFns } from "./Batches.vue?vue&type=template&id=60048bd5"
import script from "./Batches.vue?vue&type=script&lang=ts"
export * from "./Batches.vue?vue&type=script&lang=ts"
import style0 from "./Batches.vue?vue&type=style&index=0&id=60048bd5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports